/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapGetters, mapMutations } from 'vuex';

import { FlashCardExerciseTypeMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardExerciseTypeMixin';
import { FlashCardFilterCheckMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardFilterCheckMixin';
import { FlashCardFilterSwitchMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardFilterSwitchMixin';

export default {
  name: 'FlashCardFilter',

  mixins: [
    //
    FlashCardExerciseTypeMixin,
    FlashCardFilterCheckMixin,
    FlashCardFilterSwitchMixin,
  ],

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_modalCardType: 'modalCardType',
    }),

    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_isNoCard: 'isNoCard',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    toggleFilter() {
      if (this.mg_isNoCard) {
        this.$emit('close-card-modal');
      } else {
        this.mm_SET_MODAL_CARD_TYPE('');
      }
    },

    filterReading() {
      this.$emit('filter-reading');
    },
  },
};
